import { render, staticRenderFns } from "./LogicalNumber.vue?vue&type=template&id=bb77fc80"
import script from "./LogicalNumber.vue?vue&type=script&lang=js"
export * from "./LogicalNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports